import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import { SORT_ITEM } from "../Containers/TableSum/TableSum";
import { formatDate } from "utility.js";

const STORE_TABLESUM = "tablesum";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class TableSumStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      const name = this.configStore.items[item.ItemId];
      item.ItemName =
        typeof name !== "undefined"
          ? name + (item.ItemRate ? " " + item.ItemRate : "")
          : "-";
      item.CleaningRatesText = item.CleaningRates.map((cleaningrate) => {
        return this.configStore.cleaningRates[cleaningrate.CleaningRate].split(
          "-"
        )[0];
      }).join(", ");
      item.LocationsText = item.Locations.map((location) => {
        return this.configStore.locationsById[location]
          ? this.configStore.locationsById[location].Name
          : "-";
      }).join(", ");

      item.CleaningRates = item.CleaningRates.map((cleaningrate) => {
        cleaningrate.CleaningRateText =
          this.configStore.cleaningRates[cleaningrate.CleaningRate].split(
            "-"
          )[0];
        cleaningrate.LocationsText = cleaningrate.Locations.map((location) => {
          return this.configStore.locationsById[location]
            ? this.configStore.locationsById[location].Name
            : "-";
        }).join(", ");
        return cleaningrate;
      });

      item.FilterField = (
        item.ItemName +
        " " +
        item.CleaningRates.map((cleaningrate) => {
          return this.configStore.cleaningRates[item.CleaningRate];
        }).join(" ") +
        " " +
        item.LocationsText +
        " " +
        item.SumQuantity +
        " " +
        item.PalletCount
      ).toLowerCase();
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @computed get filteredItems() {
    if (!this.search) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }
        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems =
      [SORT_ITEM].indexOf(this.sortField) > -1
        ? this.filteredItems.slice().sort((a, b) => {
            if (!a[this.sortField]) return -1;
            if (!b[this.sortField]) return 1;
            return a[this.sortField]
              ? a[this.sortField].localeCompare(b[this.sortField])
              : -1;
          })
        : this.filteredItems.slice().sort((a, b) => {
            const v1 = parseInt(a[this.sortField]);
            const v2 = parseInt(b[this.sortField]);
            if (v1 === v2) return 0;
            return v1 > v2 ? 1 : -1;
          });

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems; //.slice(this.pager.firstShownItem - 1, this.pager.lastShownItem);
  }

  @observable details;
  @action setDetails(value) {
    this.details = value;
  }
}

export { TableSumStore, STORE_TABLESUM as STORE_TABLESUM, SORT_ASC, SORT_DESC };
